// DO NOT EDIT THIS FILE !!!! GENERATED DURING BUILD TYPE : Ansible
export const DOL_VERSION='[production]8.0.20-13218(c005e3c803)-C14/09/2026-16:38:46-B14/09/2026-16:52:22' ;
export const DOL_VERSION_JSON = {
  dolVersion: "[production]8.0.20-13218(c005e3c803)-C14/09/2026-16:38:46-B14/09/2026-16:52:22",
  branch: "production",
  latestTag: "8.0.20",
  revCount: "13218",
  shortHash: "c005e3c803",
  longHash: "c005e3c8031656d01b58290c8eac04b560b8469d",
  dateCommit: "14/09/2026-16:38:46",
  dateBuild: "14/09/2026-16:52:22",
  buildType: "Ansible",
  } ;
